import React from "react";

// Import components
const HomePage = React.lazy(() => import("./pages/HomePage"));

//Linux Components
const LinuxProcessManagementViz = React.lazy(() => import("./components/LinuxProcessManagementViz"));
const LinuxBootingViz = React.lazy(() => import("./components/LinuxBootingViz"));
const UnixMemoryManagementViz = React.lazy(() => import("./components/UnixMemoryManagementViz"));
const LinuxCommandsViz = React.lazy(() => import("./components/LinuxCommandsViz"));
const LinuxFileSystemViz = React.lazy(() => import("./components/LinuxFileSystemViz"));

//Network Components
const OSIModelViz = React.lazy(() => import("./components/OSIModelViz"));
const DNSResolverViz = React.lazy(() => import("./components/DNSResolverViz"));
const ARPViz = React.lazy(() => import("./components/ARPViz"));
const IdentityAndAcessManagementViz = React.lazy(() => import("./components/IdentityAndAcessManagementViz"));
const NATViz = React.lazy(() => import("./components/NATViz"));

//GCP Components
const GCPServicesViz = React.lazy(() => import("./components/GCPServicesViz"));
const GCPStorageClassesAndServicesViz = React.lazy(() => import("./components/GCPStorageClassesAndServicesViz"));

//AI Components
const AIBranchesViz = React.lazy(() => import("./components/AIBranchesViz"));

//Python Components
const PythonMetaProgrammingDecoratorsViz = React.lazy(() => import("./components/PythonMetaProgrammingDecoratorsViz"));
const PythonConcurrencyParallelismViz = React.lazy(() => import("./components/PythonConcurrencyParallelismViz"));
const OOPSPythonViz = React.lazy(() => import("./components/OOPSPythonViz"));
const PythonDataStructuresViz = React.lazy(() => import("./components/PythonDataStructuresViz"));
const PythonProgramExecutionViz = React.lazy(() => import("./components/PythonProgramExecutionViz"));
const PythonExceptionExplorerViz = React.lazy(() => import("./components/PythonExceptionExplorerViz"));

const routesConfig = [
  {
    path: "/",
    element: HomePage,
    label: "Home Page",
  },
  {
    path: "/linuxprocessmanagementviz",
    element: LinuxProcessManagementViz,
    label: "LinuxProcessManagementViz",
  },
  {
    path: "/unixmemorymanagementviz",
    element: UnixMemoryManagementViz,
    label: "UnixMemoryManagementViz",
  },
  {
    path: "/linuxbootingviz",
    element: LinuxBootingViz,
    label: "LinuxBootingViz",
  },
  {
    path: "/linuxcommandsviz",
    element: LinuxCommandsViz,
    label: "LinuxCommandsViz",
  },
  {
    path: "/linuxfilesystemviz",
    element: LinuxFileSystemViz,
    label: "LinuxFileSystemViz",
  },
  {
    path:"/osimodelviz",
    element:OSIModelViz,
    label:"OSIModelViz",
  },
  {
    path:"/dnsresolverviz",
    element:DNSResolverViz,
    label:"DNSResolverViz",
  },
  {
    path:"/natviz",
    element:NATViz,
    label:"NATViz",
  },
  {
    path:"/pythonprogramexecutionviz",
    element:PythonProgramExecutionViz,
    label:"PythonProgramExecutionViz",
  },
  {
    path:"/gcpstorageclassesandservicesviz",
    element:GCPStorageClassesAndServicesViz,
    label:"GCPStorageClassesAndServicesViz",
  },
  {
    path:"/arpviz",
    element:ARPViz,
    label:"ARPViz",
  },
  {
    path:"/iamviz",
    element:IdentityAndAcessManagementViz,
    label:"IdentityAndAcessManagementViz"
  },
  {
    path:"/pythondatastructuresviz",
    element:PythonDataStructuresViz,
    label:"PythonDataStructuresViz"
  },
  {
    path:"/gcpservicesviz",
    element:GCPServicesViz,
    label:"GCPServicesViz"
  },
  {
    path:"/oopspythonviz",
    element:OOPSPythonViz,
    label:"OOPSPythonViz"
  },
  {
    path:"/pythonconcurrecncyparallelismviz",
    element:PythonConcurrencyParallelismViz,
    label:"PythonConcurrencyParallelismViz"
  },
  {
    path:"/aibranchesviz",
    element:AIBranchesViz,
    label:"AIBranchesViz"
  },
  {
    path:"/pythonmetaprogrammingdecoratorsviz",
    element:PythonMetaProgrammingDecoratorsViz,
    label:"PythonMetaProgrammingDecoratorsViz"
  },
  {
    path:"/pythonexceptionexplorerviz",
    element:PythonExceptionExplorerViz,
    label:"PythonExceptionExplorerViz"
  }
];

export default routesConfig;
